import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';

/**
 * End ImageLoad performance data point
 * @param loadDataPoint the data point
 * @param type the type of image
 * @param howLoad how the image loaded, for attachment, this is either same domain or cross domain
 * @param error end the data point with error if error is specified, otherwise success
 * @param context the context, it can be RP, draft, or compose
 * @param loaderCode loader specific code
 * @param field1 extra field1
 */
export default function endImageLoadPerfDataPoint(
    loadDataPoint: PerformanceDatapoint,
    type: string,
    howLoad: string,
    error: string = '',
    context: string = '',
    loaderCode: string = '',
    field1: string = ''
) {
    loadDataPoint.addCustomData([type, howLoad, error, context, loaderCode, field1]);
    if (error && error.length > 0) {
        loadDataPoint.endWithError(DatapointStatus.ClientError);
    } else {
        loadDataPoint.end();
    }
}
